<template>
  <div id="report_period_container">
    <b-form-select id="report_period" v-model="period">
      <option value="5min">5 Min</option>
      <option value="hour">Hour</option>
      <option value="day">Day</option>
    </b-form-select>
  </div>
</template>

<script>
export default {
  name: 'ReportPeriod',

  computed : {
    period : {
       get : function(){
         return this.$store.helpers.report_period_name();
      },

      set : function(v){
        this.$router.push("/reports/" + v + '/' +
                this.$store.state.report.section);
      }
    }
  }
}
</script>

<style scoped>
#report_period{
  position: absolute;
  bottom: 0;
  font-size: 0.8em;
}

#report_period_container{
 position: relative;
 height: 100%;
}
</style>
